import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fgb-products-page',
  templateUrl: './products-page.component.html',
  styleUrls: ['./products-page.component.scss'],
})
export class ProductsPageComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
